export default __webpack_public_path__ + "static/PrezydentMG-428a59b9dd7beb051e3fef38807364d0.jpg";